module.exports = __webpack_public_path__ + "media/images/redes_sociales/facebook-5793e1d1e62a80ff405064a96fcbae2d.svg";